import { GUEST_COUNT_STRATEGY } from "@/enums";

const MAX_DIGITS = 5;

export default {
	props: {
		date: String,
		dailyGC: Array,
		isClosed: Boolean,
		isBeforeMeasStarted: Boolean,
		defaults: Array,
		defaultType: String,
		guestCountStrategy: String,
		stLen: Number,
	},

	data() {
		return { GUEST_COUNT_STRATEGY };
	},

	methods: { parseToNumber },

	computed: {
		dailySum,
		isDefault,
	},
};

// eslint-disable-next-line complexity
function parseToNumber(event, index) {
	// allow only positive values or null
	let value = event.target.value ? Math.abs(Number(event.target.value)) : null;

	if (value !== null && value.toString().length && value.toString().length > MAX_DIGITS) {
		const stringValue = value.toString();
		value = Number(stringValue.substring(0, MAX_DIGITS));
	}

	event.target.value = value;

	this.$emit("update", this.date, index, value);

	this.$set(this.isDefault, index, value === null);
}

function dailySum() {
	// sum the first stLen elements in dailyGC. If a value is null, use the default value
	return this.dailyGC
		.slice(0, this.stLen)
		.reduce((acc, curr, index) => acc + (curr === null ? this.defaults[index] : curr), 0);
}

function isDefault() {
	return this.dailyGC.map((gc) => gc === null);
}
